import { Dispatch } from 'redux'
import axios from '../../../config/axios'
import { setTaskDetailsReport, setTaskDetailsReportLoading, setTaskDetailsReportError } from './slice'

export const fetchTaskDetailsReport = () => async (dispatch: Dispatch) => {
  try {
    dispatch(setTaskDetailsReportLoading(true))
    dispatch(setTaskDetailsReportError(null))

    const response = await axios.get('/report/task/details')
    dispatch(setTaskDetailsReport(response.data))
  } catch (error) {
    console.error('Error fetching task details report:', error)
    dispatch(
      setTaskDetailsReportError(
        error instanceof Error
          ? error.message
          : 'An unknown error occurred while fetching task details report',
      ),
    )
  } finally {
    dispatch(setTaskDetailsReportLoading(false))
  }
}
